import { Model, AccessorsMutatorsDecorator } from "../../helpers";

/**
 * @class NumberFormat
 * @property {string} token
 * @property {string} expired_at
 */
export class NumberFormat extends Model {
  static get NUMBER_FORMATS() {
    return {
      "1000.00": {
        formatter: Intl.NumberFormat("EN", {
          style: "decimal",
          minimumFractionDigits: 2,
          useGrouping: false,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ".",
          delimiter: "",
        },
      },
      "1000,00": {
        formatter: Intl.NumberFormat("DE", {
          style: "decimal",
          minimumFractionDigits: 2,
          useGrouping: false,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ",",
          delimiter: "",
        },
      },
      "1.000,00": {
        formatter: Intl.NumberFormat("DE", {
          style: "decimal",
          minimumFractionDigits: 2,
          useGrouping: true,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ",",
          delimiter: ".",
        },
      },
      "1,000.00": {
        formatter: Intl.NumberFormat("EN", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: true,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ".",
          delimiter: ",",
        },
      },
      "1,000.0000": {
        formatter: Intl.NumberFormat("EN", {
          style: "decimal",
          useGrouping: true,
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        }),
        params: {
          numeralDecimalScale: 4,
          numeralDecimalMark: ".",
          delimiter: ",",
        },
      },
      "1 000,00": {
        formatter: Intl.NumberFormat("FR", {
          style: "decimal",
          minimumFractionDigits: 2,
          useGrouping: true,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ",",
          delimiter: " ",
        },
      },
      "1 000.00": {
        formatter: Intl.NumberFormat("FR", {
          style: "decimal",
          minimumFractionDigits: 2,
          useGrouping: true,
        }),
        params: {
          numeralDecimalScale: 2,
          numeralDecimalMark: ".",
          delimiter: " ",
        },
      },
    };
  }

  static toOriginal(value, currentFormatType) {
    let formattedValue;
    switch (currentFormatType) {
      case "1000.00":
        formattedValue = value;
        break;
      case "1000,00":
        formattedValue = value.replace(/,/g, ".");
        break;
      case "1.000,00":
        formattedValue = value.replace("/./g", "").replace(/,/g, ".");
        break;
      case "1,000.00":
      case "1,000.0000":
        formattedValue = value.replace(/,/g, "");
        break;
      case "1 000,00":
        formattedValue = value.replace("/ /g", "").replace(/,/g, ".");
        break;
      case "1 000.00":
        formattedValue = value.replace("/ /g", "");
        break;
    }

    return Number(formattedValue);
  }

  static format(value, formatType) {
    let formatter = (this.NUMBER_FORMATS[formatType] || {}).formatter;

    if (formatter) {
      let formattedValue = formatter.format(value);

      if (formatType === "1 000.00") {
        formattedValue = formattedValue.replace(/,/g, ".");
      }

      return formattedValue;
    }

    return value;
  }

  static params(formatType) {
    return (this.NUMBER_FORMATS[formatType] || {}).params;
  }
}

AccessorsMutatorsDecorator("token", "expired_at")(NumberFormat);



// WEBPACK FOOTER //
// ./src/pms-api/models/number-format.model.js